import { FC } from 'react';
import styled from 'styled-components';
import { ClinicLocationUtils } from '../../common/utils/services/clinic-location-utils';
import breakpoints from '../../design-system/breakpoints';
import OvTable from '../UI/molecules/OvTable';
import { ClinicLocation } from '../../common/model/dto/clinic-location';
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
import { useTranslation } from 'react-i18next';
import { CLINIC_LOCATION_PROFILE_IMAGES_PATH } from '../../api/firebase-storage';
import OvEditableAvatar from '../UI/molecules/OvEditableAvatar';
import { Resource } from '../../common/model/type/resource.enum';
import useAuthorized from '../../hooks/use-authorized';

const ClinicLocationInfo: FC<{
  selectedClinicLocation?: ClinicLocation;
  handleClinicLocationUpdate?: (obj: any) => any;
  canEdit?: boolean;
}> = ({ selectedClinicLocation, handleClinicLocationUpdate, canEdit }) => {
  const { t } = useTranslation();

  const applicationOperations = useAuthorized(Resource.Application);
  const clinicLocationOperations = useAuthorized(Resource.ClinicLocation);

  const clinicLocationUpdateAllowed =
    clinicLocationOperations.update || applicationOperations.supervise;

  return (
    <Container>
      <OvEditableAvatar
        entity={selectedClinicLocation}
        handleUpdate={handleClinicLocationUpdate}
        imageBasePath={CLINIC_LOCATION_PROFILE_IMAGES_PATH}
        dialogTitle={t('clinicLocationDialogs.clinicLocationImageUploadTitle')}
        defaultImageComponent={<ProfileImage />}
      />

      <TableWrapper>
        <OvTable
          data={ClinicLocationUtils.mapClinicLocationToTableDataFormat(
            selectedClinicLocation,
            canEdit
          )}
          theme="Light"
          onSaveRowValue={handleClinicLocationUpdate}
          editable={clinicLocationUpdateAllowed}
        />
      </TableWrapper>
    </Container>
  );
};

export default ClinicLocationInfo;

const Container = styled.div`
  display: flex;
  gap: 1rem;

  @media (max-width: ${breakpoints.md}) {
    flex-direction: column;
    align-items: center;
  }
`;

const TableWrapper = styled.div`
  flex-grow: 1;
  align-self: flex-start;
  min-width: 0;
  width: 100%;
`;

const ProfileImage = styled(LocalHospitalIcon)`
  && {
    width: 12rem !important;
    height: 12rem !important;
    border: 0.375rem solid;
    border-radius: 50%;
    margin-bottom: 0.25rem;
    padding: 0.75rem;
  }
`;
